/**
 * أعداد الكيانات — تبويبان مستقلان تماماً:
 *  - الأعداد العامة: العدد الكامل/المبدل/الباقي (سجل تنظيمي عام)
 *  - معايير الاستحقاق: كمية مستحقة يومياً لكل صنف لكل مديرية (لمقارنة الطلبات)
 * كلاهما مؤرَّخ بتاريخ السريان ويُعرَض حسب نفس مرشِّح التاريخ والمحافظة.
 */
import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../../api/client";
import { todayISO } from "../../lib/date";
import type { Governorate } from "../../types";
import GeneralHeadcountTab from "./GeneralHeadcountTab";
import ConsumptionNormsTab from "./ConsumptionNormsTab";

type Tab = "general" | "norms";

export default function HeadcountPage() {
  const [tab,   setTab]   = useState<Tab>("general");
  const [asOf,  setAsOf]  = useState(todayISO());
  const [govId, setGovId] = useState("");

  const { data: govs = [] } = useQuery({
    queryKey: ["governorates"],
    queryFn: () => api.get<{ data: Governorate[] }>("/governorates?isActive=true").then((r) => r.data.data),
  });

  return (
    <div>
      <div className="page-header no-print">
        <h1 className="page-title">أعداد الكيانات</h1>
        <p className="page-subtitle">الأعداد العامة، ومعايير استحقاق كل صنف — سجلّان منفصلان</p>
      </div>

      <div className="flex gap-1 mb-4 border-b border-sand-300 no-print">
        {([
          { key: "general", label: "الأعداد العامة" },
          { key: "norms",   label: "معايير الاستحقاق" },
        ] as const).map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition -mb-px ${
              tab === t.key ? "border-primary-700 text-primary-700" : "border-transparent text-sand-500 hover:text-gray-900"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="card mb-4 no-print flex flex-wrap gap-4 items-end">
        <div>
          <label className="label" htmlFor="asOf">ساري بتاريخ</label>
          <input id="asOf" type="date" className="input w-44" dir="ltr"
            value={asOf} onChange={(e) => setAsOf(e.target.value)} />
        </div>
        <div>
          <label className="label" htmlFor="gov">المحافظة</label>
          <select id="gov" className="input w-48" value={govId} onChange={(e) => setGovId(e.target.value)}>
            <option value="">كل المحافظات</option>
            {govs.map((g) => <option key={g.id} value={g.id}>{g.nameAr}</option>)}
          </select>
        </div>
      </div>

      {tab === "general" ? <GeneralHeadcountTab asOf={asOf} govId={govId} /> : <ConsumptionNormsTab asOf={asOf} govId={govId} />}
    </div>
  );
}
